class UpsellProducts extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector(".upsell-products__checkbox-input");
    this.variants = document.querySelectorAll("[data-upsell]");
    this.selectedProduct = this.dataset.variantId;
    this.descriptionNonChecked = this.querySelector(
      ".upsell-products__non-checked"
    );
    this.descriptionChecked = this.querySelector(".upsell-products__checked");
    this.priceElement = document.querySelector(
      ".product-block--price .product__price"
    );
  }

  connectedCallback() {
    if (this.checkbox) {
      this.checkbox.addEventListener(
        "change",
        this.handleCheckboxChange.bind(this)
      );
    }
    document.addEventListener(
      "variant:change",
      this.handleVariantChange.bind(this)
    );
    this.checkbox.disabled = false;
  }

  disconnectedCallback() {
    if (this.checkbox) {
      this.checkbox.removeEventListener(
        "change",
        this.handleCheckboxChange.bind(this)
      );
    }
  }

  handleVariantChange(changeEvent) {
    this.selectedProduct = changeEvent.detail.variant.id;
    this.removeUpsellFromCart();
    const array_variants = Array.from(this.variants);
    if (
      ("some",
      array_variants.some(
        (variant) =>
          Number(variant.dataset.parentId) === Number(this.selectedProduct)
      ))
    ) {
      this.setAvailableMessage();
    } else {
      this.setUnvailableMessage();
    }
  }

  setAvailableMessage() {
    this.classList.remove("unavailable");
  }

  setUnvailableMessage() {
    this.classList.add("unavailable");
  }

  handleCheckboxChange(event) {
    if (event.target.checked) {
      this.addUpsellToCart();

      if (this.priceElement) {
        this.variants.forEach((variant) => {
          if (
            Number(variant.dataset.parentId) === Number(this.selectedProduct)
          ) {
            const price = Number(
              this.priceElement.textContent.replace(/[^0-9.]/g, "")
            );
            this.priceElement.textContent =
              ((price + Number(variant.dataset.price)) / 100)
                .toFixed(2)
                .replace(".", ",") + " €";
          }
        });
      }
    } else {
      this.removeUpsellFromCart();

      if (this.priceElement) {
        this.variants.forEach((variant) => {
          if (
            Number(variant.dataset.parentId) === Number(this.selectedProduct)
          ) {
            const price = Number(
              this.priceElement.textContent.replace(/[^0-9.]/g, "")
            );
            this.priceElement.textContent =
              ((price - Number(variant.dataset.price)) / 100)
                .toFixed(2)
                .replace(".", ",") + " €";
          }
        });
      }
    }
  }

  async addUpsellToCart() {
    this.variants.forEach((variant) => {
      if (Number(variant.dataset.parentId) === Number(this.selectedProduct)) {
        variant.selected = true;
        this.descriptionChecked.querySelector(
          ".upsell-products__title"
        ).textContent = variant.dataset.productTitle;
        this.descriptionChecked.querySelector(
          ".upsell-products__variant-title"
        ).textContent = variant.dataset.variantTitle;
        this.descriptionChecked.querySelector(
          ".upsell-products__size-title"
        ).textContent = variant.dataset.sizeTitle;
      }
    });
      this.descriptionChecked.querySelector(
        ".upsell-products__count"
      ).textContent = Array.from(this.variants).filter(variant => Number(variant.dataset.parentId) === Number(this.selectedProduct)).length + "x";

    this.descriptionNonChecked.classList.add("hidden");
    this.descriptionChecked.classList.remove("hidden");
  }

  async removeUpsellFromCart() {
    this.checkbox.checked = false;
    this.variants.forEach((variant) => (variant.selected = false));
    this.descriptionNonChecked.classList.remove("hidden");
    this.descriptionChecked.classList.add("hidden");
  }
}

if (!customElements.get("upsell-products")) {
  customElements.define("upsell-products", UpsellProducts);
}

export default UpsellProducts;
